module.exports = __webpack_public_path__ + "fonts/VetoSans-LightItalic_1.c50ef658.woff2";